import { BundlePaymentPlan, BundleType } from 'multirpc-sdk';

import { EMilliSeconds } from 'modules/common/constants/const';

import {
  BundleChargingModel,
  BundleChargingModelBalance,
  BundleChargingModelUsage,
} from '../types';
import { CREDITS_TO_REQUESTS_RATE, CREDITS_TO_USD_RATE } from '../constants';

export interface GetDefaultFreemiumChargingModelParams {
  plans: BundlePaymentPlan[];
}

export const getDefaultFreemiumChargingModel = ({
  plans,
}: GetDefaultFreemiumChargingModelParams) => {
  const freemiumPlan = plans?.find(
    plan => plan.bundle.type === 'FREE_ALLOWANCE_FREEMIUM',
  );

  const creditsLimit =
    freemiumPlan?.bundle.limits.find(({ type }) => type === BundleType.COST)
      ?.limit || 0;

  const balance: BundleChargingModelBalance = {
    credits: creditsLimit,
    requests: creditsLimit / CREDITS_TO_REQUESTS_RATE,
    usd: creditsLimit / CREDITS_TO_USD_RATE,
  };

  const used = 0;
  const usagePercent = 0;
  const leftPercent = 100;

  const usage: BundleChargingModelUsage = {
    leftPercent,
    limit: creditsLimit,
    percent: usagePercent,
    used,
  };

  const now = new Date();

  const chargingModel: BundleChargingModel = {
    balance,
    // first day of next month in seconds
    expires: Math.floor(
      new Date(now.getFullYear(), now.getMonth() + 1, 1).getTime() /
        EMilliSeconds.Second,
    ),
    type: 'freemium',
    usage,
  };

  return chargingModel;
};
